var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetShot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,21H3c-1.6,0-3-1.3-3-3V6c0-1.6,1.3-3,3-3h18c1.6,0,3,1.3,3,3v12C24,19.7,22.7,21,21,21z M3,5C2.4,5,2,5.4,2,6v12 c0,0.5,0.4,1,1,1h18c0.5,0,1-0.4,1-1V6c0-0.5-0.4-1-1-1H3z M5,7.8H4C3.6,7.8,3.2,7.4,3.2,7S3.6,6.2,4,6.2h1c0.4,0,0.8,0.3,0.8,0.8 S5.4,7.8,5,7.8z M5,12.8H4c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h1c0.4,0,0.8,0.3,0.8,0.8C5.8,12.4,5.4,12.8,5,12.8z  M5,17.8H4c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h1c0.4,0,0.8,0.3,0.8,0.8S5.4,17.8,5,17.8z M20,7.8h-1c-0.4,0-0.8-0.3-0.8-0.8 s0.3-0.8,0.8-0.8h1c0.4,0,0.8,0.3,0.8,0.8S20.4,7.8,20,7.8z M20,12.8h-1c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h1 c0.4,0,0.8,0.3,0.8,0.8C20.8,12.4,20.4,12.8,20,12.8z M20,17.8h-1c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h1c0.4,0,0.8,0.3,0.8,0.8 S20.4,17.8,20,17.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetShot);
export default __webpack_public_path__ + "static/media/assetShot.c64267a5070c96023a9435fee7ab1391.svg";
export { ForwardRef as ReactComponent };